import React from 'react'

import {
  Button, Close, Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

function ReportModalHeader({ closeModal }) {
  return (
    <div className="report-modal__header">
      <h1 className="report-modal__title">Report content</h1>
      <div className="report-modal__close-button-container">
        <Button
          size="small"
          type="ghost"
          variant="only-icon"
          customClass="report-modal__close-button"
          onClick={closeModal}
          icon={<Icon svgComponent={Close} />}
        />
      </div>
    </div>
  )
}

ReportModalHeader.propTypes = {
  closeModal: func.isRequired,
}

export default ReportModalHeader
